<template>
  <b-button
    type="button"
    class="parcel_view"
    variant="primary"
    size="sm"
    @click="viewParcel"
  >
    <b-icon-eye />
  </b-button>
</template>

<script>
import {
  BButton, BIconEye,
} from 'bootstrap-vue'
import { EventBus } from '@core/utils/utils'

export default {
  components: {
    BButton,
    BIconEye,
  },
  props: ['declaration', 'parcel'],
  methods: {
    viewParcel() {
      EventBus.$emit('set-view-parcel', this.declaration, this.parcel)
    },
  },
}
</script>

<style scoped>
  svg {
    font-size: 1em;
  }
</style>
